var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoginIllustration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1400 750",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Login_Page_17"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1077.5
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Login_Page_17",
    "data-name": "Login Page \\u2013 17",
    clipPath: "url(#clip-Login_Page_17)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_249",
    "data-name": "Ellipse 249",
    cx: 118.5,
    cy: 118.5,
    r: 118.5,
    transform: "translate(987.865 139.012)",
    fill: "#0F4CDB"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_248",
    "data-name": "Ellipse 248",
    transform: "translate(952.865 130.012)",
    fill: "none",
    stroke: "#2d2d2d",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 123,
    cy: 123,
    r: 123,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 123,
    cy: 123,
    r: 122,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1691",
    "data-name": "Path 1691",
    d: "M580.37,786.466l-1.386-1.441c.274-.264,27.555-26.977,37.951-76.9,9.6-46.1,6.358-121.991-63.615-221.769-29.237-41.689-49.175-81.078-59.26-117.071-8.241-29.41-9.985-56.75-5.186-81.26,9.489-48.459,41.741-69.734,42.065-69.943l1.083,1.681c-.318.205-31.9,21.08-41.2,68.708-10.673,54.644,10.9,120.836,64.133,196.736,31.082,44.321,51.772,87.721,61.5,128.994,7.79,33.063,8.6,64.844,2.412,94.459C608.316,759.141,580.648,786.2,580.37,786.466Z",
    transform: "translate(-30.924 -50.94)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_231",
    "data-name": "Ellipse 231",
    cx: 77.414,
    cy: 77.414,
    r: 77.414,
    transform: "translate(434.89 123.929)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1692",
    "data-name": "Path 1692",
    d: "M531.48,324.4A105.478,105.478,0,1,1,636.958,218.926,105.478,105.478,0,0,1,531.48,324.4Zm0-208.956A103.478,103.478,0,1,0,634.958,218.926,103.478,103.478,0,0,0,531.48,115.449Z",
    transform: "translate(-0.924 -50.94)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_232",
    "data-name": "Ellipse 232",
    cx: 64.197,
    cy: 64.197,
    r: 64.197,
    transform: "translate(575.521 312.744)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_233",
    "data-name": "Ellipse 233",
    cx: 64.197,
    cy: 64.197,
    r: 64.197,
    transform: "translate(472.793 535.546)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1695",
    "data-name": "Path 1695",
    d: "M1107.256,786.551l-.706-.205a114.056,114.056,0,0,1,28.716-47.775l.494.544a113.285,113.285,0,0,0-28.5,47.436Z",
    transform: "translate(214.608 38.38)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1696",
    "data-name": "Path 1696",
    d: "M957.619,786.5l-.728-.1a80.08,80.08,0,0,0-7.2-46.807A64.447,64.447,0,0,0,938.32,723l.509-.531a65.257,65.257,0,0,1,11.518,16.793,80.814,80.814,0,0,1,7.272,47.234Z",
    transform: "translate(361.775 -85.183)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1697",
    "data-name": "Path 1697",
    d: "M149.538,786.239l-.5-1.031c-.153-.313-15.188-31.743-6.805-62.731s37.213-50.553,37.5-50.746l.953-.638.5,1.031c.153.313,15.188,31.743,6.8,62.731s-37.212,50.553-37.5,50.746ZM179.88,674.076c-5.047,3.672-28.4,21.862-35.718,48.922-7.326,27.081,3.674,54.545,6.183,60.258,5.047-3.672,28.4-21.862,35.718-48.922h0C193.388,707.252,182.388,679.788,179.88,674.076Z",
    transform: "translate(25.076 -50.94)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1698",
    "data-name": "Path 1698",
    d: "M110.773,734.594c8.382,30.986,37.093,50.176,37.093,50.176s15.121-31.047,6.738-62.033-37.093-50.176-37.093-50.176S102.391,703.609,110.773,734.594Z",
    transform: "translate(25.076 -50.94)",
    fill: "#DF459C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1699",
    "data-name": "Path 1699",
    d: "M149.99,785.805l-1.145-.062c-.349-.019-35.123-2.162-58.126-24.555s-26.081-57.1-26.109-57.445l-.093-1.142,1.145.063c.349.019,35.123,2.162,58.126,24.555s26.081,57.1,26.109,57.445ZM66.732,704.756c.754,6.2,5.3,35.445,25.383,55s49.447,23.308,55.661,23.9c-.754-6.2-5.3-35.444-25.383-55h0C102.291,709.082,72.943,705.341,66.732,704.756Z",
    transform: "translate(25.076 -50.94)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1700",
    "data-name": "Path 1700",
    d: "M174.711,727.935c-23,22.39-25.81,56.81-25.81,56.81s34.482-1.883,57.483-24.273,25.81-56.81,25.81-56.81S197.712,705.545,174.711,727.935Z",
    transform: "translate(5.076 -50.94)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1701",
    "data-name": "Path 1701",
    d: "M361.711,533.935c-23,22.39-25.81,56.81-25.81,56.81s34.482-1.883,57.483-24.273,25.81-56.81,25.81-56.81S384.712,511.545,361.711,533.935Z",
    transform: "translate(5.076 -50.94)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_234",
    "data-name": "Ellipse 234",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(158.497 586.508)",
    fill: "#0F4CDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1702",
    "data-name": "Path 1702",
    d: "M330.4,785.465l-1.386-1.441c.218-.209,21.855-21.4,30.1-61.008,7.611-36.577,5.026-96.8-50.511-175.993-42.594-60.736-59.831-113.8-51.231-157.717,7.555-38.582,33.25-55.531,33.508-55.7l1.083,1.681c-.251.163-25.272,16.712-32.642,54.463-8.462,43.352,8.669,95.879,50.918,156.122,24.708,35.231,41.156,69.733,48.887,102.547,6.2,26.3,6.84,51.573,1.917,75.13C352.65,763.713,330.624,785.252,330.4,785.465Z",
    transform: "translate(5.076 -50.94)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_235",
    "data-name": "Ellipse 235",
    cx: 180,
    cy: 30.88,
    rx: 180,
    ry: 30.88,
    transform: "translate(145.497 270.747)",
    fill: "#8F4CE6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1703",
    "data-name": "Path 1703",
    d: "M286.921,374.449c-124.766,0-222.5-17.131-222.5-39s97.734-39,222.5-39,222.5,17.131,222.5,39S411.687,374.449,286.921,374.449Zm0-76c-119.523,0-220.5,16.944-220.5,37s100.977,37,220.5,37,220.5-16.944,220.5-37S406.445,298.449,286.921,298.449Z",
    transform: "translate(5.076 -50.94)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1704",
    "data-name": "Path 1704",
    d: "M337.482,183.893s-26.674-7.514-34.563,28.928-1.878,54.85-1.878,54.85l59.546-6.95S377.492,194.976,337.482,183.893Z",
    transform: "translate(5.076 -50.94)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1705",
    "data-name": "Path 1705",
    d: "M297.575,341.729s-39.126,3.9-32.157,19.693,6.969,17.19,6.969,17.19l34.379,61.325,11.15-11.615s-12.544-27.411-12.544-36.238-13.008-24.159-13.008-24.159l22.765-1.858Z",
    transform: "translate(5.076 -50.94)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1706",
    "data-name": "Path 1706",
    d: "M404.794,360.492l13.008,28.34s9.756,9.756,20.442,48.782,13.008,37.632,13.008,37.632L434.992,478.5s-18.119-42.277-24.159-45.529-13.473-32.986-13.473-32.986l-21.371-26.946,6.5-14.4Z",
    transform: "translate(5.076 -50.94)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1707",
    "data-name": "Path 1707",
    d: "M389,327.971l19.977,37.167s-25.088-11.615-28.8,13.938l-22.765-17.654s-31.592,10.221-50.64,6.5c0,0,5.575-17.654-14.4-25.552l45.065-5.575-1.858-9.756,4.646-9.292Z",
    transform: "translate(5.076 -50.94)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1708",
    "data-name": "Path 1708",
    d: "M309.553,431.574s-12.544-1.858-9.292,9.292l6.5,22.3s-8.363,22.765,4.646,17.654,21.371-36.7,21.371-36.7,5.575-24.159,0-24.159-23.229-3.717-21.371,0S309.553,431.574,309.553,431.574Z",
    transform: "translate(5.076 -50.94)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1709",
    "data-name": "Path 1709",
    d: "M449.859,468.741s-16.261-4.181-19.977,2.323-2.788,27.875-2.788,28.34,5.575,5.11,7.433,5.11S448,525.42,463.8,517.987,449.859,468.741,449.859,468.741Z",
    transform: "translate(8.622 -47.446)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_236",
    "data-name": "Ellipse 236",
    cx: 18.119,
    cy: 18.119,
    r: 18.119,
    transform: "translate(319.74 153.45)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1710",
    "data-name": "Path 1710",
    d: "M347.65,226.227s3.717,19.513,6.969,22.3S330,255.5,330,255.5s4.181-13.473-.929-20.442S347.65,226.227,347.65,226.227Z",
    transform: "translate(5.076 -50.94)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1711",
    "data-name": "Path 1711",
    d: "M396.431,336.8c-3.164,0-11.22-1.31-20.251-3-7.814-1.459-16.367-3.192-23.113-4.595-7.224-1.505-12.386-2.63-12.386-2.63s-1.858,11.615-7.9,10.221c-5.2-1.2-20.753-55.513-24.958-70.524a5.222,5.222,0,0,1,2.309-5.868l21.357-13.041,5.473,2.091s9.245-7.145,14.611-7.289,14.658-1.538,14.658-1.538,10.685.929,12.544,8.827,2.788,57.144,9.756,65.971S405.258,336.8,396.431,336.8Z",
    transform: "translate(5.076 -50.94)",
    fill: "#d0cde1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1712",
    "data-name": "Path 1712",
    d: "M331.389,362.815s0,18.119,12.079,15.331.929-19.513.929-19.513Z",
    transform: "translate(5.076 -50.94)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1713",
    "data-name": "Path 1713",
    d: "M364.839,364.673s-4.181,21.371-13.008,18.119,0-22.3,0-22.3Z",
    transform: "translate(5.076 -50.94)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1714",
    "data-name": "Path 1714",
    d: "M384.352,314.033S379.8,324.886,376.18,333.8c-7.814-1.459-16.367-3.192-23.113-4.595a13.3,13.3,0,0,1,2.016-3.559c3.252-3.717,1.394-4.646,1.394-4.646-2.788-5.575-.465-13.008-.465-13.008-5.575-14.867,2.788-33.45,2.788-33.45Z",
    transform: "translate(5.076 -50.94)",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1715",
    "data-name": "Path 1715",
    d: "M360.193,274.544s-8.363,18.583-2.788,33.45c0,0-2.323,7.433.465,13.008,0,0,1.858.929-1.394,4.646s-6.04,16.725-3.717,19.513-3.252,7.9-1.858,10.685-2.323,6.5-2.323,6.5,13.938,2.788,16.261,6.969c0,0,2.788-3.252,1.394-6.969s-.465-5.11.929-7.433,5.575-7.433,6.04-9.756,12.544-31.127,12.544-31.127l-5.665-52.492Z",
    transform: "translate(5.076 -50.94)",
    fill: "#d0cde1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1716",
    "data-name": "Path 1716",
    d: "M311.876,261.535l-.868.158a5.222,5.222,0,0,0-4.29,5.177c.033,4.665.3,12.943,1.442,24.4,1.858,18.583,8.363,46.459,9.756,49.246a148.289,148.289,0,0,0,7.433,14.4c4.181,6.969,5.11,4.646,4.181,7.9a4.893,4.893,0,0,0,1.394,5.11s8.363-9.292,16.725-4.181a10.352,10.352,0,0,0,.929-4.181c0-2.323,1.394-4.646-.929-6.04s1.394-7.433-2.323-10.685-4.181-2.788-3.717-6.04a13.839,13.839,0,0,0-.929-6.5Z",
    transform: "translate(5.076 -50.94)",
    fill: "#d0cde1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1717",
    "data-name": "Path 1717",
    d: "M339.557,199.235s-7.514,19.911-25.922,28.176l-3.005-17.657Z",
    transform: "translate(5.076 -50.94)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_237",
    "data-name": "Ellipse 237",
    cx: 2.555,
    cy: 4.878,
    rx: 2.555,
    ry: 4.878,
    transform: "translate(352.958 159.722)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_238",
    "data-name": "Ellipse 238",
    cx: 32.454,
    cy: 32.454,
    r: 32.454,
    transform: "translate(1234.133 356.125)",
    fill: "#d9d9d9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_239",
    "data-name": "Ellipse 239",
    cx: 10.78,
    cy: 10.78,
    r: 10.78,
    transform: "translate(1251.473 335.174)",
    fill: "#d9d9d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1718",
    "data-name": "Path 1718",
    d: "M859.347,403.905a10.781,10.781,0,0,1,.921-14.43q-.452.291-.883.631A10.78,10.78,0,0,0,872.8,406.989a10.639,10.639,0,0,0,.815-.717,10.781,10.781,0,0,1-14.264-2.367Z",
    transform: "translate(390.775 -51.274)",
    fill: "#d9d9d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1719",
    "data-name": "Path 1719",
    d: "M822.655,557.219l-18.784,15.894s-28.176,8.67-14.449,18.062,21.674-11.56,21.674-11.56l23.119-14.449Z",
    transform: "translate(390.775 -51.274)",
    fill: "#ffb9b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1720",
    "data-name": "Path 1720",
    d: "M863.113,487.862l-2.167-1.445s-8.67,0-10.115,8.67-5.78,26.731-5.78,26.731-14.449,8.67-13,24.564l-15.172,13s18.062,5.78,14.449,10.837l26.731-24.564.722-46.96Z",
    transform: "translate(390.775 -51.274)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_240",
    "data-name": "Ellipse 240",
    cx: 18.784,
    cy: 18.784,
    r: 18.784,
    transform: "translate(1243.773 382.403)",
    fill: "#ffb9b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1721",
    "data-name": "Path 1721",
    d: "M866,465.465s11.56,13,4.335,20.229-9.392,42.626-9.392,42.626l31.789-48.405s-8.67-17.339-7.947-23.119Z",
    transform: "translate(390.775 -51.274)",
    fill: "#ffb9b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1722",
    "data-name": "Path 1722",
    d: "M863.836,516.038s17.339-38.084,26.731-40.716l24.564,6.037s-19.507,67.19-17.339,73.692,14.449,15.894,10.115,72.969c0,0,55.63,101.868,41.9,119.207s-65.022,30.344-65.745,25.286-23.841-83.084-20.229-106.925c0,0,0,103.313-4.335,105.48s-73.692,18.062-71.524,5.78,36.846-147.384,36.846-147.384l26.731-83.806.722-12.282s-11.56-7.947-2.89-26.009,11.56-20.952,11.56-20.952l10.408-1.954S861.668,510.981,863.836,516.038Z",
    transform: "translate(390.775 -51.274)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1723",
    "data-name": "Path 1723",
    d: "M902.849,570.223l-8.67,18.784s-22.4,23.841-6.5,24.564S905.017,591.9,905.017,591.9l11.56-21.674Z",
    transform: "translate(390.775 -51.274)",
    fill: "#ffb9b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1724",
    "data-name": "Path 1724",
    d: "M905.739,482.082h9.392s2.89-4.335,5.78,13.727,1.445,45.516,1.445,45.516l-4.335,36.123s-15.172-5.78-18.784-4.335,0-.722,0-.722l6.5-24.564-7.947-35.4Z",
    transform: "translate(390.775 -51.274)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1725",
    "data-name": "Path 1725",
    d: "M869.882,424.763c-12.27,3.334-20.639,11.838-18.695,19,.87,3.2,3.665,5.586,7.579,6.95l3.435-4.261.156,5.171c.543.093,1.095.175,1.663.236l4.364-9.19,2.488,9.157a38.652,38.652,0,0,0,6.052-1.14c12.27-3.334,20.639-11.838,18.695-19S882.151,421.43,869.882,424.763Z",
    transform: "translate(390.775 -51.274)",
    fill: "#d9d9d9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_241",
    "data-name": "Ellipse 241",
    cx: 2.167,
    cy: 3.612,
    rx: 2.167,
    ry: 3.612,
    transform: "translate(1279.536 393.601)",
    fill: "#ffb9b9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_242",
    "data-name": "Ellipse 242",
    cx: 17,
    cy: 7.5,
    rx: 17,
    ry: 7.5,
    transform: "translate(1191.196 720.174)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_243",
    "data-name": "Ellipse 243",
    cx: 22.795,
    cy: 10,
    rx: 22.795,
    ry: 10,
    transform: "translate(1279.926 721.353) rotate(-21.513)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1726",
    "data-name": "Path 1726",
    d: "M795.663,581.41c-.3-.073-30.459-7.614-41.934-37.566-13.08-34.139,2.3-82.28,45.7-143.087,53.017-74.27,55.9-99.225,48.975-107.081-8.754-9.938-36.224,3.519-36.5,3.656l-.918-1.783c1.187-.589,29.164-14.291,38.953-3.181C860.7,304.576,844.267,341.429,801.1,401.9c-23.521,32.951-38.9,62.527-45.694,87.908-5.513,20.577-5.44,38.508.217,53.3,11.08,28.966,40.232,36.288,40.525,36.359Z",
    transform: "translate(389.056 -50.968)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_244",
    "data-name": "Ellipse 244",
    cx: 10.533,
    cy: 10.533,
    r: 10.533,
    transform: "translate(1018.196 223.861)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_245",
    "data-name": "Ellipse 245",
    cx: 10.533,
    cy: 10.533,
    r: 10.533,
    transform: "translate(1135.13 223.861)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1728",
    "data-name": "Path 1728",
    d: "M754.888,328.609c0,3.132-20.314,12.153-45.372,12.153s-45.372-9.021-45.372-12.153,20.314.81,45.372.81S754.888,325.477,754.888,328.609Z",
    transform: "translate(390.775 -51.274)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1287",
    "data-name": "Rectangle 1287",
    width: 1152.417,
    height: 2.509,
    transform: "translate(157.765 733.804)",
    fill: "#3f3d56"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginIllustration);
export default __webpack_public_path__ + "static/media/login_illustration.60e76554.svg";
export { ForwardRef as ReactComponent };